export default __webpack_public_path__ + "static/media/109t.cbeecd7d.jpg";